import { jwtDecode } from "jwt-decode";

interface WhiteLabelTokenData {
  workspace_id: string;
  account_id?: string;
}

interface WhiteLabelToken {
  data: WhiteLabelTokenData;
  iat: number;
  exp: number;
}

async function parseToken(token: string) {
  if (!token) {
    return Promise.resolve({ data: null });
  }
  try {
    const decoded = jwtDecode<WhiteLabelToken>(token);
    if (decoded.exp && Date.now() >= decoded.exp * 1000) {
      return Promise.reject({ error: "Token has expired" });
    }
    return Promise.resolve({ ...decoded });
  } catch (error) {
    return Promise.reject({ error });
  }
}

export default parseToken;
